'use strict';

function GAEventTriggers() {
	
	this.initGAEventTriggers = function () {
		// Check for Google Analytics and jQuery
		if (typeof ga === 'function' && typeof $ === 'function') {
			$(document).on('click', '.ga-event-trigger', function() {
				ga('send', {
				  hitType: 'event',
				  eventCategory: $(this).attr('data-ga-category'),
				  eventAction: 'click',
				  eventLabel: $(this).text()
				});
			});
		}
	};
}